export enum ComplaintType {
    TRAFFIC = 1,
    HEALTH = 2,
    EDUCATION = 3,
    HEALTH_SURVEILANCE = 4,
    ENVIRONMENT = 5,
    FIREFIGHTERS = 6,
    ZOONOSIS = 7,
    DEMAND = 8
}

const complaintDescription = {
    [ComplaintType.TRAFFIC]: 'Infraestrutura/Trânsito',
    [ComplaintType.HEALTH]: 'Saúde',
    [ComplaintType.EDUCATION]: 'Educação',
    [ComplaintType.HEALTH_SURVEILANCE]: 'Vigilância Sanitária',
    [ComplaintType.ENVIRONMENT]: 'Meio Ambiente',
    [ComplaintType.FIREFIGHTERS]: 'Defesa Civil/Corpo de bombeiros',
    [ComplaintType.ZOONOSIS]: 'Zoonoses',
    [ComplaintType.DEMAND]: 'Reclamação/Outros'
}

export function getComplaintDescription(type: number) {
    const description = complaintDescription[type as ComplaintType];
    if (!description) {
        throw new Error('Invalid complaint type. Value received: ' + type);
    }
    return description;
}